import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { InternalLinks } from "@/components/InternalLinks";
import { licenses } from "@/data/licenses";

export function LicenseHubPage() {
  const { t, lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const title = isSv
    ? "Spellicenser för casinon — komplett jämförelse"
    : "Casino licenses — full comparison";
  const desc = isSv
    ? "Förstå skillnaden mellan svensk licens, MGA, Curaçao, Estland och UKGC."
    : "Understand the difference between the Swedish license, MGA, Curaçao, Estonia and UKGC.";
  const base = `${prefix}/${isSv ? "licenser" : "licenses"}`;

  return (
    <div className="container-page py-8">
      <SEO title={title} description={desc} />
      <Breadcrumbs items={[{ label: t("nav.home"), href: prefix }, { label: title }]} />
      <h1 className="mt-3 text-3xl font-extrabold md:text-4xl">{title}</h1>
      <p className="mt-2 max-w-3xl text-ink-700">{desc}</p>

      <article className="prose prose-ink mt-6 max-w-3xl [&>h2]:mt-8 [&>h2]:mb-3 [&>h2]:text-2xl [&>h2]:font-bold [&>p]:my-3">
        <h2>{isSv ? "Varför licens spelar roll" : "Why the license matters"}</h2>
        <p>
          {isSv
            ? "Spelbolagets licens avgör vilka regler det måste följa, hur tvister hanteras, om Spelpaus gäller och hur stor del av insatserna som går tillbaka till spelarna i form av RTP-kontroll. Olika licenser har olika krav på bonusar, max insats, KYC och konsumentskydd. Här är en kort genomgång — klicka in på varje för fullständig information."
            : "An operator's license decides which rules it must follow, how disputes are handled, whether Spelpaus applies, and how strict the RTP supervision is. Different licenses have different requirements around bonuses, max bet, KYC and consumer protection. Here is a brief overview — click each for full details."}
        </p>
      </article>

      <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {licenses.map((l) => (
          <Link
            key={l.id}
            to={`${base}/${l.slug}`}
            className="card-interactive p-5 no-underline"
          >
            <h3 className="text-lg font-semibold">{isSv ? l.name_sv : l.name_en}</h3>
            <p className="mt-1 text-xs uppercase tracking-wide text-ink-500">
              {l.jurisdiction}
            </p>
            <p className="mt-2 text-sm text-ink-700 line-clamp-4">
              {isSv ? l.description_sv : l.description_en}
            </p>
          </Link>
        ))}
      </div>

      <InternalLinks context="license" />
    </div>
  );
}
